import React, { ReactNode, useEffect } from 'react';

import { readLocalStorageData, saveLocalStorageData } from '@app/services/localStorage.service';
import { setNavigateFunction } from '@app/services/redirectService';
import { LocalStorageItems } from '@shared/constants/localStorageItems';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

type WithChildrenProps<T = undefined> = T extends undefined
	? {
			children?: ReactNode;
			publicPaths?: Record<string, ReactNode>;
		}
	: T & {
			children?: ReactNode;
			publicPaths?: Record<string, ReactNode>;
		};

const RequireAuth: React.FC<WithChildrenProps> = ({ children, publicPaths }) => {
	const navigate = useNavigate();
	const { pathname, search } = useLocation();

	useEffect(() => {
		setNavigateFunction(navigate);
	}, [navigate]);

	const isAuth = readLocalStorageData(LocalStorageItems.isAuth);

	if (!isAuth) {
		const publicFallback = publicPaths?.[pathname];
		if (publicFallback) return <>{publicFallback}</>;

		// Preserve the full target URL (incl. query params) so login can redirect back to it.
		saveLocalStorageData(LocalStorageItems.redirectUrl, pathname + search);
		return <Navigate to='/auth/login' replace />;
	}

	return <>{children}</>;
};

export default RequireAuth;
